import { injectable } from 'inversify';
import { plainToClass } from 'class-transformer';

import { Filter, FilterService } from '@vk-hr-tek/core/filter';
import { ValidationService } from '@vk-hr-tek/core/validation';

import { UsersService } from '@app/gen/attorneys';

import { GetAttorneysUsersDto } from '../../dto';

@injectable()
export class AttorneysUsersService {
  constructor(
    private usersService: UsersService,
    private filterService: FilterService,
    private validator: ValidationService,
  ) {}

  async get(
    getAttorneysUsersDto: GetAttorneysUsersDto,
    availableFilters: Filter[],
  ) {
    const attorneysUsersDto = plainToClass(
      this.filterService.buildDto(GetAttorneysUsersDto, availableFilters),
      getAttorneysUsersDto,
    );

    await this.validator.validateOrReject(attorneysUsersDto);

    const { offset, limit, company_id: companyId, filters } = attorneysUsersDto;

    const result = await this.usersService.attorneyUserList({
      body: {
        offset,
        limit,
        filter: { ...filters, company_id: companyId },
      },
    });

    return {
      data: result.attorney_users,
      total: result.total,
    };
  }
}
